<template>
  <div>
    <!-- WCAG 2.4.1: Skip to main content bypass block -->
    <a href="#main-content" class="skip-link">Skip to main content</a>

    <ApplicationHeader />

    <!--- This blocks router/child components from loading until accesstoken is loaded, or possibly errored out-->
    <LoadingAccessToken v-if="sessionStore.accessToken === '' || sessionStore.uvid == '' " />
    <InvalidSession v-else-if="sessionStore.invalidAccessToken || sessionStore.session_issues" />
    <main v-else id="main-content" tabindex="-1">
      <router-view />
    </main>

    <div class="vstack fixed-bottom">
      <error-messages v-for="(error_message, error_index) in sessionStore.error_messages" :key="error_index" :error_message="error_message" :error_index="error_index"/>
    </div>


  </div>
</template>


<script lang="ts">

//const toTimestamp = (strDate : string) => Date.parse(strDate);

//import axios from 'axios';

import { useSessionStore } from './stores/SessionStore'
import { AuthService } from './services/auth'
import { EnvService } from './services/env'

import { defineComponent, onMounted, reactive } from 'vue'
import { AccountInfo } from '@azure/msal-common';

import ApplicationHeader from './components/ApplicationHeader.vue'

import InvalidSession from './components/common/InvalidSession.vue'
import LoadingAccessToken from './components/common/LoadingAccessToken.vue'
import ErrorMessages from './components/common/ErrorMessages.vue'

export default defineComponent({
  setup() {
    
    const authService = reactive(new AuthService())
    const sessionStore = useSessionStore()
    const envService = new EnvService()

    onMounted(async () => {
      // console.log(authService)
    })
    

    return { authService, sessionStore, envService}
  },
  data() {
    return {
    }
  },
  name: 'App',
  components: { ApplicationHeader, InvalidSession, LoadingAccessToken, ErrorMessages },

  async mounted() {
    await this.authService.loadAuthModule()
    
    this.sessionStore.app_title = this.envService.getAttribute("VUE_APP_TITLE")
    this.sessionStore.app_name = this.envService.getAttribute("VUE_APP_NAME")
    this.sessionStore.backend_path = this.envService.getAttribute("VUE_APP_BACKEND_PATH")

    await this.renew_access_token()
    await this.refresh_environment()

    // if(this.backend_path && !this.sessionStore.invalidAccessToken){
    //   let {data} = (await axios.get(`${this.backend_path}/environment`, this.authService.auth_header())).data;
    //   this.environment = data.environment
    // }

    setInterval(() => {
      if(this.sessionStore.session_issues) return false
      this.renew_access_token()
    }, 30000);

    // setInterval(() => {
    //   this.refresh_environment()
    // }, 10000);
  },
  methods: {
    
    async refresh_environment(){
        const func_name = "Loading Environment"
        const path = `/environment`
        this.sessionStore.request_data('get', path, func_name, {})
          .then(data => this.sessionStore.environment = data.environment)
      },

      async renew_access_token () {
        await this.authService.acquireAccessToken()
      }
  },

  watch: {

    'authService.username': function() {
      // since the username is returned in the format of uvid@uvu.edu - but then moved it down to the accessToken watch, since sometimes people can login with their named account - i.e. david.nielsen@uvu.edu
      //this.sessionStore.uvid = username.indexOf('@') > 0 ? username.substr(0, username.indexOf('@')) : ''
      const usernames = this.authService.getAccountsUserNames()
      this.sessionStore.updateAccountUserNames(usernames)

      const account: AccountInfo | undefined = this.authService.getAccount()
      this.sessionStore.updateUserAccount(account)
    },

    'authService.accessToken' : function(accessToken) {
      
      const claims = JSON.parse(atob(accessToken.split('.')[1]))
      const upn = claims.upn
      this.sessionStore.uvid = upn.indexOf('@') > 0 ? upn.substr(0, upn.indexOf('@')) : ''
      
      this.sessionStore.updateAccessToken(accessToken)
    },

    'sessionStore.app_title' : function(title) {
      document.title = title
    },

  }

});
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* WCAG 2.4.1: Skip link - visually hidden until focused */
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #00843e;
  color: #fff;
  padding: 8px 16px;
  z-index: 9999;
  text-decoration: none;
  font-weight: bold;
  &:focus {
    top: 0;
  }
}

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }

.bg-uvu {
    background-color: #00843e !important;
}
</style>
